import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    // AUDIT_CLOSE_FAILURE: "AUDIT_CLOSE_FAILURE",
    // AUDIT_CLOSE_REQUEST: "AUDIT_CLOSE_REQUEST",
    // AUDIT_CLOSE_SUCCESS: "AUDIT_CLOSE_SUCCESS",

    AUDIT_ITEM_CLEAR: "AUDIT_ITEM_CLEAR",
    AUDIT_ITEM_SET: "AUDIT_ITEM_SET",

    // AUDIT_PATCH_FAILURE: "AUDIT_PATCH_FAILURE",
    // AUDIT_PATCH_REQUEST: "AUDIT_PATCH_REQUEST",
    // AUDIT_PATCH_SUCCESS: "AUDIT_PATCH_SUCCESS",

    AUDITS_LIST_CLEAR: "AUDITS_LIST_CLEAR",

    AUDITS_LIST_GET_FAILURE: "AUDITS_LIST_GET_FAILURE",
    AUDITS_LIST_GET_REQUEST: "AUDITS_LIST_GET_REQUEST",
    AUDITS_LIST_GET_SUCCESS: "AUDITS_LIST_GET_SUCCESS"

    // AUDITS_LIST_POST_FAILURE: "AUDITS_LIST_POST_FAILURE",
    // AUDITS_LIST_POST_REQUEST: "AUDITS_LIST_POST_REQUEST",
    // AUDITS_LIST_POST_SUCCESS: "AUDITS_LIST_POST_SUCCESS",

    // AUDITS_LIST_SET: "AUDITS_LIST_SET"
};

export const actionCreators = {
    // clear: () => ({
    //     type: actionTypes.AUDITS_LIST_CLEAR
    // }),
    clearAudits: () => ({
        type: actionTypes.AUDITS_LIST_CLEAR
    }),

    // closeRequest: (auditId: number) => ({
    //     type: actionTypes.AUDIT_CLOSE_REQUEST,
    //     payload: { auditId },
    //     [WAIT_FOR_ACTION]: actionTypes.AUDIT_CLOSE_SUCCESS,
    //     [ERROR_ACTION]: actionTypes.AUDIT_CLOSE_FAILURE
    // }),
    // closeSuccess: (audit: any) => ({
    //     type: actionTypes.AUDIT_CLOSE_SUCCESS,
    //     payload: { audit }
    // }),
    // closeFailure: (error) => ({
    //     type: actionTypes.AUDIT_CLOSE_FAILURE,
    //     error
    // }),

    getRequest: (
        status: string,
        page: Number,
        pageSize: Number,
        search: string,
        auditReference: string
    ) => ({
        type: actionTypes.AUDITS_LIST_GET_REQUEST,
        payload: { status, page, pageSize, search, auditReference },
        [WAIT_FOR_ACTION]: actionTypes.AUDITS_LIST_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDITS_LIST_GET_FAILURE
    }),
    getSuccess: (audits: any) => ({
        type: actionTypes.AUDITS_LIST_GET_SUCCESS,
        payload: { audits }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.AUDITS_LIST_GET_FAILURE,
        error
    }),

    itemClear: () => ({
        type: actionTypes.AUDIT_ITEM_CLEAR
    }),
    itemSet: (audit: any) => ({
        type: actionTypes.AUDIT_ITEM_SET,
        payload: { audit }
    })

    // patchRequest: (audit: any) => ({
    //     type: actionTypes.AUDIT_PATCH_REQUEST,
    //     payload: { audit },
    //     [WAIT_FOR_ACTION]: actionTypes.AUDIT_PATCH_SUCCESS,
    //     [ERROR_ACTION]: actionTypes.AUDIT_PATCH_FAILURE
    // }),
    // patchSuccess: (audit: any) => ({
    //     type: actionTypes.AUDIT_PATCH_SUCCESS,
    //     payload: { audit }
    // }),
    // patchFailure: (error) => ({
    //     type: actionTypes.AUDIT_PATCH_FAILURE,
    //     error
    // }),

    // postRequest: (audits: Array<any>) => ({
    //     type: actionTypes.AUDITS_LIST_POST_REQUEST,
    //     [WAIT_FOR_ACTION]: actionTypes.AUDITS_LIST_POST_SUCCESS,
    //     [ERROR_ACTION]: actionTypes.AUDITS_LIST_POST_FAILURE,
    //     payload: { audits }
    // }),
    // postSuccess: (audits: any) => ({
    //     type: actionTypes.AUDITS_LIST_POST_SUCCESS,
    //     payload: { audits }
    // }),
    // postFailure: (error: Error) => ({
    //     type: actionTypes.AUDITS_LIST_POST_FAILURE,
    //     error
    // }),

    // set: (audits: Array<any>) => ({
    //     type: actionTypes.AUDITS_LIST_SET,
    //     payload: { audits }
    // })
};

export default {
    create: actionCreators,
    type: actionTypes
};
